var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"sort-by":"createdAt","sort-desc":true},scopedSlots:_vm._u([{key:"item.createdAt",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm._f("datetime")(item.createdAt)))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }